<app-modal-base
  [showCloseIcon]="true"
  [showPrimaryButton]="true"
  [showSecondaryButton]="true"
  [secondaryButtonText]="'back'"
  [primaryButtonText]="'fixNow'"
  [primaryButtonId]="'fix-billing'"
  (primaryClick)="onFixNow()"
  (secondaryClick)="dialogRef.close()"
  (close)="dialogRef.close()"
  [modalBodyClass]="'flex flex-col items-center justify-center text-center'"
>
  <i class="ph ph-warning text-4xl mb-4"></i>
  <div>
    <div class="text-lg font-semibold mb-2">
      {{ 'unableToSendPaymentRequest' | translate }}
    </div>
    <hr class="spacement my-2" />
    <div class="text-gray-500 mb-2">
      {{ 'yourAcccountIsCurrentlyRestricted' | translate }}
    </div>
  </div>
</app-modal-base>
